module.exports = ".error {\r\n\tcolor: #fc9980;\r\n}\r\n\r\n.black {\r\n\tcolor: black;\r\n}"